import env from "src/env.js";

const api = env.api;

function getDatabase() {
  const [, , db] = location.pathname.split("/");
  return db;
}

function getRequestSecurityHeaders() {
  // Unix ms UTC — same instant Date.now() / epoch uses
  const requestTime = String(Date.now());
  const noncePayload = `${crypto.randomUUID()}:${requestTime}`;
  return {
    "X-Request-Time": requestTime,
    "X-Request-Nonce": btoa(noncePayload),
  };
}

async function fetchAPI(opts, database) {
  let response, route;
  const args = {
    method: opts.method,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      ...getRequestSecurityHeaders(),
    },
  };

  const session = opts?.body?.context?.session;
  if (session) {
    args.headers.Authorization = `Bearer ${session}`;
  }

  if (opts.body) {
    args.body = JSON.stringify(opts.body, (_, v) =>
      v === undefined ? null : v,
    );
  }
  if (!database) {
    database = opts?.body?.context?.db ?? getDatabase();
  }
  route = `${api}${database}${opts.uri}`;

  let data = null;
  let error = null;
  try {
    response = await fetch(route, args);
    data = JSON.parse(await response.text());
    if (response.status !== 200) {
      error = data.detail;
      data = null;
    }
  } catch (errorMsg) {
    console.log("API Error please check this: ", errorMsg);
    error = errorMsg;
  }
  return { data, error };
}

export default fetchAPI;
